import { DatePicker as AntdDatePicker } from "@empglabs/backoffice-ui-kit"

const DatePicker = props => {
  return <AntdDatePicker {...props} />
}
export default DatePicker
